import React from 'react'
import styled from 'styled-components';
import theme from 'themes';
type CustomProps = {
    margin?: string;
    padding?: string;
}
type TextAreaProps =  React.TextareaHTMLAttributes<HTMLTextAreaElement> & CustomProps
const StyledTextarea = styled.textarea<CustomProps>`
    width: 100%;
    padding: ${({ padding }) => padding || undefined};
    margin: ${({ margin }) => margin || undefined};
    border: 0.0625rem solid ${({ theme }) => theme.colors.primaryBlue4};
    box-shadow: ${({ theme }) => theme.colors.borders.border02.shadow};
    border-radius: 0.375rem;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 0.0625rem 0.125rem 0px;
    border: 0.0625rem solid rgb(216, 221, 227) !important;
    font-size: 90%;
    :focus {
        outline: 1px solid ${theme.colors.primaryBlue5};
        box-shadow: 0px 0px 1px 2px rgba(0, 118, 204, 0.15);
    }
    :hover {
        outline: 1px solid ${theme.colors.primaryBlue5};
    }

        /* Disable hover when textarea is disabled */
    &:disabled {
        cursor: not-allowed;
        opacity: 0.9;
        
        /* Remove hover effect when disabled */
        &:hover {
            outline: none;
        }
    }
    
`;

const StyledTextArea = (props: TextAreaProps): JSX.Element => {
    return (
        <StyledTextarea {...props} />
    )
}

export default StyledTextArea
